type DragState = {
  isDown: boolean;
  startX: number;
  scrollLeft: number;
  isDragging: boolean;
};

function createHorizontalScrollHandlers(el: HTMLElement) {
  const state: DragState = {
    isDown: false,
    startX: 0,
    scrollLeft: 0,
    isDragging: false,
  };

  const handleMouseDown = (e: MouseEvent) => {
    state.isDown = true;
    state.isDragging = false;
    state.startX = e.clientX - el.offsetLeft;
    state.scrollLeft = el.scrollLeft;
    el.classList.add('cursor-grabbing');
  };

  const handleMouseLeave = () => {
    state.isDown = false;
    el.classList.remove('cursor-grabbing');
  };

  const handleMouseUp = () => {
    state.isDown = false;
    setTimeout(() => {
      state.isDragging = false;
    }, 0);
    el.classList.remove('cursor-grabbing');
  };

  const handleMouseMove = (e: MouseEvent) => {
    if (!state.isDown) return;
    e.preventDefault();
    const x = e.clientX - el.offsetLeft;
    const walk = x - state.startX;
    if (Math.abs(walk) > 5) state.isDragging = true;
    el.scrollLeft = state.scrollLeft - walk;
  };

  const handleClick = (e: MouseEvent) => {
    if (state.isDragging) {
      e.stopPropagation();
      e.preventDefault();
    }
  };

  const getState = () => state; // for testing

  return {
    handleMouseDown,
    handleMouseLeave,
    handleMouseUp,
    handleMouseMove,
    handleClick,
    getState,
  };
}

export { createHorizontalScrollHandlers };
export type { DragState };
